import axios from 'axios';
const qs = require('qs');

declare global {
  interface Window {
    [key: string]: any;
  }
}

class RequestHelper {

  _token = '';
  _afterEachCall = undefined;
  _beforeEachCall = undefined;

  setToken = (tokens) => {
    this._token = tokens;
  }

  getToken = () => {
    return this._token;
  }

  makeHeader = (method, isUpload = false) => {
    if (typeof this._beforeEachCall === 'function') this._beforeEachCall();
    let token = this.getToken();
    let headers = {
      'Accept': 'application/json, text/plain, */*',
    };
    if(token) headers["xc-auth"] = token;
    if(method === "POST" || method === "PUT" ) headers["Content-Type"] = "application/json";
    if(isUpload) {
      headers["Content-Type"] = 'multipart/form-data';
    }
    return headers;
  }

  querify = (url, queryObject) => {
    let newUrl = url;
    if(!queryObject) return newUrl;
    newUrl += "?" + qs.stringify(queryObject);
    return newUrl;
  }

  getNoHeader = async (URL, queryObject) => {
    const urlWithQuery = this.querify(URL, queryObject);
    const res = await axios.request({
      url: urlWithQuery,
      method: 'get',
      headers: {},
    });
    return {
      headers: res.headers,
      json: async () => res.data,
      text: async () => res.data,
      data: res.data,
    };
  }

  get = async (URL, queryObject) => {
    try {
      const urlWithQuery = this.querify(URL, queryObject);
      const res = await axios.request({
        url: urlWithQuery,
        method: 'get',
        headers: this.makeHeader("GET"),
      });
      return {
        headers: res.headers,
        json: async () => res.data,
        text: async () => res.data,
        data: res.data,
      };
    } catch(err) {
      if (err.response) {
        const res = err.response;
        return {
          headers: res.headers,
          json: async () => res.data,
          text: async () => res.data,
          data: res.data,
        }
      }
    }
    
  }

  post = async (URL, bodyObject) => {
    try {
      const res = await axios.request({
        url: URL,
        method: 'post',
        headers: this.makeHeader("POST"),
        data: JSON.stringify(bodyObject),
      });
      return {
        headers: res.headers,
        json: async () => res.data,
        text: async () => res.data,
        data: res.data,
      };
    } catch(err) {
      if (err.response) {
        const res = err.response;
        return {
          headers: res.headers,
          json: async () => res.data,
          text: async () => res.data,
          data: res.data,
        }
      }
      
    }
  }

  postUpload = async (URL, bodyObject, callback = (e) => {}) => {
    const res =  await axios.request({
      url: URL,
      method: 'post',
      headers: this.makeHeader("POST", true),
      data: bodyObject,
      onUploadProgress: (progressEvent) => {
        callback(progressEvent.loaded/progressEvent.total)
        // console.log(progressEvent.loaded/progressEvent.total)
      }
    })
    return {
      headers: res.headers,
      json: async () => res.data,
      text: async () => res.data,
      data: res.data,
    };
  }

  put = async (URL, bodyObject) => {
    const res = await axios.request({
      url: URL,
      method: 'put',
      headers: this.makeHeader("PUT"),
      data: JSON.stringify(bodyObject)
    });
    return {
      headers: res.headers,
      json: async () => res.data,
      text: async () => res.data,
      data: res.data,
    };
  }

  delete = async (URL) => {
    const res = await axios.request({
      url: URL,
      method: 'delete',
      headers: this.makeHeader("DELETE"),
      // data: JSON.stringify(bodyObject)
    });
    return {
      headers: res.headers,
      json: async () => res.data,
      text: async () => res.data,
      data: res.data,
    };
  }

}

const requestHelper = new RequestHelper();
// @ts-ignore
window.requestHelper = requestHelper;
export default requestHelper;